import { Role } from '$api-client/types.gen'

export class PermissionsHelper {
  static hasRole(userRole: Role, requiredRoles: Role[]): boolean {
    return requiredRoles.includes(userRole)
  }

  static doesntHaveRole(userRole: Role, requiredRoles: Role[]): boolean {
    return !this.hasRole(userRole, requiredRoles)
  }
}
